export function isPdfUrl(url) {
  if (!url?.trim()) return false;
  const path = url.split("?")[0].toLowerCase();
  return path.endsWith(".pdf") || path.includes(".pdf");
}

export function isImageUrl(url) {
  if (!url?.trim()) return false;
  const path = url.split("?")[0].toLowerCase();
  return /\.(jpe?g|png|gif|webp|bmp|svg|avif)$/i.test(path);
}

export function resolveCertificateFile(item) {
  const candidates = [
    item.certificate_image,
    item.image_url,
    item.image,
    item.document_url,
    item.documentUrl,
  ]
    .map((url) => url?.trim())
    .filter(Boolean);

  let image = null;
  let documentUrl = null;
  let fileUrl = null;
  let fileType = null;

  for (const url of candidates) {
    if (isPdfUrl(url)) {
      if (!documentUrl) documentUrl = url;
      if (!fileUrl) {
        fileUrl = url;
        fileType = "pdf";
      }
      continue;
    }

    if (!image && (isImageUrl(url) || item.certificate_image === url || item.image_url === url || item.image === url)) {
      image = url;
      if (!fileUrl) {
        fileUrl = url;
        fileType = "image";
      }
    }
  }

  if (!fileUrl && candidates[0]) {
    fileUrl = candidates[0];
    fileType = isPdfUrl(candidates[0]) ? "pdf" : "image";
    if (fileType === "pdf") documentUrl = documentUrl || candidates[0];
    else image = image || candidates[0];
  }

  return { image, documentUrl, fileUrl, fileType };
}
